import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
} from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { getCrashData } from '../../api/api';
import { useNavigate } from 'react-router-dom'; //

const CrashDataTable = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [startDate, setStartDate] = useState(dayjs().subtract(90, 'days'));
  const [endDate, setEndDate] = useState(dayjs());
  const [loading, setLoading] = useState(false);

  // Fetch data from API
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getCrashData({
        params: {
          // startDate: startDate.format('YYYY-MM-DD'),
          // endDate: endDate.format('YYYY-MM-DD'),
          page: page + 1,
          limit: rowsPerPage,
        },
      });

      setData(response.data.records);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      console.error('Error fetching crash data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, startDate, endDate]);

  // Handle pagination change
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page
  };

  const handleDateChange = () => {
    setPage(0); // Reset to first page when date range changes
    fetchData();
  };

  const handleRowClick = (id) => {
    navigate(`/crash-data/${id}`); // Navigate to detail page with incident ID
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box p={3}>
        <Paper elevation={3} sx={{ p: 2, mb: 2 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <DatePicker
              label="Start Date"
              value={startDate}
              onChange={(newValue) => setStartDate(newValue)}
              renderInput={(params) => <TextField {...params} />}
            />
            <DatePicker
              label="End Date"
              value={endDate}
              onChange={(newValue) => setEndDate(newValue)}
              renderInput={(params) => <TextField {...params} />}
            />
            <Button variant="contained" onClick={handleDateChange} disabled={loading}>
              Apply Date Range
            </Button>
          </Box>
        </Paper>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Crash ID</TableCell>
                <TableCell>Primary Address</TableCell>
                <TableCell>Secondary Address</TableCell>
                <TableCell>Crash Severity</TableCell>
                <TableCell>Units Involved</TableCell>
                <TableCell>Total Injuries</TableCell>
                <TableCell>Death Count</TableCell>
                <TableCell>Crash Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item) => (
                <TableRow key={item._id}
                  onClick={() => handleRowClick(item._id)} // Add click handler
                  style={{ cursor: 'pointer' }}>
                  <TableCell>{item.ID}</TableCell>
                  <TableCell>{item['Crash ID']}</TableCell>
                  <TableCell>{item['Primary address']}</TableCell>
                  <TableCell>{item['Secondary address']}</TableCell>
                  <TableCell>{item.crash_sev_id}</TableCell>
                  <TableCell>{item.units_involved}</TableCell>
                  <TableCell>{item.tot_injry_cnt}</TableCell>
                  <TableCell>{item.death_cnt}</TableCell>
                  <TableCell>{dayjs(item['Crash timestamp']).format('YYYY-MM-DD')}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={totalRecords}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default CrashDataTable;
